import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { ApiConfiguration } from './julia-agent-openapi/api-configuration';
import { JuliaChatComponent } from './julia-chat/julia-chat.component';
import { ActionPreviewModalComponent } from './action-preview-modal/action-preview-modal.component';
import { SendEmailPreviewComponent } from './actions-previews-loaders/send-email-preview/send-email-preview.component';
import { CustomMarkdownComponent } from '../../base-components/custom-markdown/custom-markdown.component';
import { environment } from '../../../environments/environment';

@NgModule({
  declarations: [
    JuliaChatComponent,
    ActionPreviewModalComponent,
    SendEmailPreviewComponent,
    CustomMarkdownComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    TranslateModule,
    MarkdownModule.forRoot({ loader: HttpClient }),
  ],
  exports: [JuliaChatComponent],
  providers: [
    {
      provide: ApiConfiguration,
      useFactory: () => {
        const config = new ApiConfiguration();
        config.rootUrl = environment.juliaApiUrl;
        return config;
      },
    },
  ],
})
export class JuliaAgentModule {}